import { IAnalyticsLayout } from "@formant/core/model/IAnalyticsLayout";
import { IAnalyticsModule } from "@formant/core/model/IAnalyticsModule";
import { ITaskReportColumn } from "@formant/core/model/ITaskReportColumn";
import { IView } from "@formant/core/model/IView";

import { analyticsModuleStore, viewStore } from "../../../stores";

export const taskReportToModule = (
    taskReport: ITaskReportColumn,
    view: IView,
): IAnalyticsModule => {
    const name = taskReport.columnName || "Module";
    const module = {
        name,
        layout: {},
        data: [],
        configuration: {
            parameters: {},
        },
        query: {
            parameters: [],
            tableColumns: [taskReport],
            deviceIds: view?.filter?.deviceIds || [],
            orderByColumn: "TIMESTAMP",
            type: "task",
        },
        streamIds: [],
    } as IAnalyticsModule;
    return module;
};

export const createAnalyticsModule = async (
    viewInput: IView,
    modules: IAnalyticsModule[],
) => {
    const view = viewInput;
    const layout = view.layout as IAnalyticsLayout;
    let [x, y] = [0, 0];
    const height = 5;
    const width = 5;

    for (const module of modules) {
        const newModule = await analyticsModuleStore.save(module);
        const { id } = newModule;

        const newRect = {
            x,
            y,
            height,
            width,
        };

        x += width;
        if (x > 0 && x % (2 * width) === 0) {
            y += height;
            x = 0;
        }

        const moduleId = "analytics-module:" + id;

        const configuration = {
            parameters: {
                AnalyticsModuleName: newModule.name,
                AnalyticsModuleDefinitionId: id,
                query: newModule.query,
                configuration: {
                    ...newModule.configuration,
                    chartType: "line",
                },
            },
        };
        layout[moduleId] = {
            ...newRect,
            configuration: {
                ...configuration,
                moduleType: "analytics",
            },
        };
        view.layout = layout;
    }
    await viewStore.save(view);
};
